var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobBurgerClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.318115 14.1455C-0.105957 14.5696 -0.105957 15.2576 0.318115 15.6819C0.742432 16.106 1.43042 16.106 1.85449 15.6819L8 9.53638L14.1455 15.6819C14.5696 16.106 15.2576 16.106 15.6819 15.6819C16.106 15.2576 16.106 14.5696 15.6819 14.1455L9.53638 8L15.6819 1.85449C16.106 1.43042 16.106 0.742432 15.6819 0.318115C15.2576 -0.105957 14.5696 -0.105957 14.1455 0.318115L8 6.46362L1.85449 0.318115C1.43042 -0.105957 0.742432 -0.105957 0.318115 0.318115C-0.105957 0.742432 -0.105957 1.43042 0.318115 1.85449L6.46362 8L0.318115 14.1455Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobBurgerClose);
export default __webpack_public_path__ + "static/media/mob-burger-close.8e7f8f37e7b86298b35db99abe7d29e1.svg";
export { ForwardRef as ReactComponent };